/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgCountByFilter { 
    /**
     * Count of orgs in filtered ransomware recovery deployments
     */
    org_count?: number;
    /**
     * Value of ransomware recovery deployment filter
     */
    value?: string;
}

